// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"592b1ec8","290":"95f62fb3","552":"3cffc46d","629":"f70f7c82","656":"b85d175b","828":"6528320b"}[chunkId] + ".chunk.css";
};